<template>
  <div class="activate-location-confirmation">
    <div class="confirmation-header">
      <div class="title">
        <font-awesome-icon
          icon="check-circle"
          class="icon activate-icon"
          size="2x"
          fixed-width
        />
        <h3>Activate Location</h3>
      </div>
    </div>

    <div
      v-if="errorMessage"
      class="error-message alert alert-danger"
    >
      {{ errorMessage }}
    </div>

    <div class="confirmation-content">
      <div class="location-details">
        <h4>{{ location.name }}</h4>
        <div class="address">
          <div>{{ location.address.address_line_1 }}</div>
          <div v-if="location.address.address_line_2">
            {{ location.address.address_line_2 }}
          </div>
          <div>
            {{ location.address.locality }}, {{ location.address.administrative_district_level_1 }} {{ location.address.postal_code }}
          </div>
          <div>{{ location.address.country }}</div>
        </div>
        <div
          v-if="location.description"
          class="description"
        >
          {{ location.description }}
        </div>
      </div>

      <div class="confirmation-message">
        <p><strong>Do you really want to re-activate this location?</strong></p>
        <p>The location will become available when selecting a location.</p>
      </div>
    </div>

    <div class="confirmation-actions">
      <b-button
        variant="secondary"
        :disabled="processing"
        @click="handleCancel"
      >
        Cancel
      </b-button>
      <b-button
        variant="success"
        :disabled="processing"
        @click="handleActivate"
      >
        <b-spinner
          v-if="processing"
          small
          class="mr-2"
        />
        Activate Location
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activate-location-confirmation',
  props: {
    location: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      processing: false,
      errorMessage: ''
    }
  },
  methods: {
    handleActivate() {
      this.processing = true
      this.errorMessage = ''

      this.$store.dispatch('square/activateLocation', this.location.id)
        .then(resp => {
          setTimeout(() => {
            this.processing = false
            this.errorMessage = ''
            this.$emit('activated', this.location)
          }, 500)
        })
        .catch((error) => {
          this.processing = false
          this.errorMessage = error.message || 'An error occurred while activating the location.'
        })
    },

    handleCancel() {
      this.errorMessage = ''
      this.processing = false
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.activate-location-confirmation {
  padding: 2rem;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  background-color: #fff;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);

  .confirmation-header {
    margin-bottom: 1.5rem;

    .title {
      display: flex;
      align-items: center;
      gap: 1rem;

      .activate-icon {
        color: #28a745;
      }

      h3 {
        margin: 0;
        color: #28a745;
      }
    }
  }

  .error-message {
    margin-bottom: 1.5rem;
  }

  .confirmation-content {
    margin-bottom: 2rem;

    .location-details {
      background-color: #f8f9fa;
      padding: 1.5rem;
      border-radius: 0.375rem;
      margin-bottom: 1.5rem;
      border-left: 4px solid #28a745;

      h4 {
        margin-bottom: 1rem;
        color: #495057;
        font-weight: 600;
      }

      .address {
        margin-bottom: 1rem;
        line-height: 1.5;
        color: #6c757d;

        div {
          margin-bottom: 0.25rem;
        }
      }

      .description {
        font-style: italic;
        color: #6c757d;
      }
    }

    .confirmation-message {
      p {
        margin-bottom: 0.75rem;

        &:last-child {
          margin-bottom: 0;
        }
      }

      strong {
        color: #28a745;
      }
    }
  }

  .confirmation-actions {
    display: flex;
    gap: 0.75rem;
    justify-content: flex-end;

    .btn {
      min-width: 120px;
    }
  }
}
</style>
